import { Landmark } from "lucide-react";
import { useTranslations } from "next-intl";

import { useCustomerAccount } from "@/providers";

import ActionIconButton from "./action-icon-button";
import DepositDetailsDrawer from "./deposit-details/deposit-details-drawer";

interface DepositButtonProps {
  accountId?: string;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
  showIcon?: boolean;
  showAccountSelect?: boolean;
  labelClassName?: string;
}

export default function DepositButton({
  accountId,
  variant = "outline",
  className,
  showAccountSelect = false,
  labelClassName,
}: DepositButtonProps) {
  const tAccounts = useTranslations("accounts");
  const { isAccountSuspended } = useCustomerAccount();

  const label = (
    <>
      <span>{tAccounts("accountDetailsLine1")}</span>
      <span>{tAccounts("accountDetailsLine2")}</span>
    </>
  );

  // View-only (suspended) accounts: no deposit-details drawer — the button
  // stays visible but disabled, with the tooltip explaining why.
  if (isAccountSuspended) {
    return (
      <div data-testid="deposit-button">
        <ActionIconButton
          icon={Landmark}
          label={label}
          disabled
          tooltipText={tAccounts("suspendedViewOnly")}
          variant={variant}
          className={className}
          iconClassName="text-emerald-400"
          strokeWidth={2}
          labelClassName={labelClassName}
        />
      </div>
    );
  }

  return (
    <DepositDetailsDrawer
      trigger={
        <div data-testid="deposit-button">
          <ActionIconButton
            icon={Landmark}
            label={label}
            variant={variant}
            className={className}
            iconClassName="text-emerald-400"
            strokeWidth={2}
            trigger={undefined}
            labelClassName={labelClassName}
          />
        </div>
      }
      initialAccountId={accountId}
      showAccountSelect={showAccountSelect}
    />
  );
}
